import { useEffect } from 'react';
import expertPusherChannelController from 'utils/pusher/expert';
import useGetExpertLoggedInUserData from 'hooks/Authentication/useGetExpertLoggedInUserData';

const { useChannel, createOrUpdate, destroy } = expertPusherChannelController;

const useExpertPusher = () => {
  const { data } = useGetExpertLoggedInUserData();
  const accountantId = data?._id;

  useEffect(() => {
    if (!accountantId) return destroy();
    createOrUpdate(accountantId);
  }, [accountantId]);

  return useChannel();
};

export default useExpertPusher;
